import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tab"
export default class extends Controller {
  switch(e) {
    Turbo.visit(e.target.value);
  }
}
